import $api from "@/frontend/shared/api/axios";
import { TMarketReportData } from "./types/types";
import { MarketReportSchema } from "@/libs/models/companies";

export async function getFounderCompanyMarketOverview() {
  const response = await $api.get<{ data: TMarketReportData }>(`/founder-revisions/market-report`);
  const parsed = MarketReportSchema.parse(response.data.data);
  return parsed;
}
